import ReplayIcon from "@mui/icons-material/Replay";
import { LoadingButton } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import { useRecordContext, useRefresh } from "react-admin";
import { useMutation } from "react-query";
import * as api from "../api/backoffice.api";
import { reportError } from "../backoffice.utils";
import { useDialog } from "../hooks/useDialog";
import { Student } from "../providers/studentsProvider";
import { DialogCloseButton } from "../misc/DialogCloseButton";

export function ResetTheoryLearningButton() {
  const { dialogProps, openDialog } = useDialog();

  return (
    <>
      <IconButton onClick={openDialog}>
        <ReplayIcon />
      </IconButton>
      <ResetTheoryLearningDialog {...dialogProps} />
    </>
  );
}

function ResetTheoryLearningDialog(props: { open: boolean; onClose: () => void }) {
  const { open, onClose } = props;
  const student = useRecordContext<Student>();
  const refresh = useRefresh();

  const { mutateAsync: resetTheoryLearning, isLoading } = useMutation(
    ["students", "getOne", { id: student.id }],
    () => api.resetTheoryLearning(student),
    {
      onSuccess: () => {
        showSuccessToast(`Lernstand von ${student.name} erfolgreich zurückgesetzt.`);
      },
      onError: (error) => {
        reportError(`Failed to reset theory learning for student ${student.name} (${student.id})`, error);
        showErrorToast(`Lernstand von ${student.name} konnte nicht zurückgesetzt werden.`);
      },
      onSettled: () => {
        onClose();
        return refresh();
      },
    },
  );

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Lernstand zurücksetzen</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <DialogContentText>
          Alle beantworteten Fragen und Prüfungssimulationen werden hierdurch zurückgesetzt. Dies kann nicht rückgängig
          gemacht werden.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          loading={isLoading}
          loadingPosition="start"
          startIcon={<ReplayIcon />}
          onClick={resetTheoryLearning}
        >
          Zurücksetzen
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
